import { DocumentData, FirestoreDataConverter, QueryDocumentSnapshot, SnapshotOptions } from 'firebase/firestore';

/**
 * Simple generic Firestore data converter.
 * Replaces the @tsed/json-mapper-based converter with plain object spread.
 */
export function firestoreConverter<T>(): FirestoreDataConverter<T> {
  return {
    toFirestore(data: T): DocumentData {
      const { id: _, ...rest } = data as Record<string, unknown>;
      return rest;
    },
    fromFirestore(snapshot: QueryDocumentSnapshot, options?: SnapshotOptions): T {
      const data = snapshot.data(options);
      return { ...data, id: snapshot.id } as T;
    },
  };
}
